@file:OptIn(InternalResourceApi::class)

package com.nonopn.skywatcher.common.app.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.nonopn.skywatcher.common.app.res/"

internal val Res.string.page_administrators_couldnt_load: StringResource by lazy {
      StringResource("string:page_administrators_couldnt_load", "page_administrators_couldnt_load", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4027, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3971, 96),
      ))
    }

internal val Res.string.page_administrators_remove_administrator_couldnt_remove_text: StringResource
    by lazy {
      StringResource("string:page_administrators_remove_administrator_couldnt_remove_text", "page_administrators_remove_administrator_couldnt_remove_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4124, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4068, 116),
      ))
    }

internal val Res.string.page_administrators_remove_administrator_text: StringResource by lazy {
      StringResource("string:page_administrators_remove_administrator_text", "page_administrators_remove_administrator_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4249, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4185, 113),
      ))
    }

internal val Res.string.page_administrators_remove_administrator_title: StringResource by lazy {
      StringResource("string:page_administrators_remove_administrator_title", "page_administrators_remove_administrator_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4367, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4299, 86),
      ))
    }

internal val Res.string.page_users_add_new_user_couldnt_invite_text: StringResource by lazy {
      StringResource("string:page_users_add_new_user_couldnt_invite_text", "page_users_add_new_user_couldnt_invite_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4458, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4386, 99),
      ))
    }

internal val Res.string.page_users_add_new_user_couldnt_invite_title: StringResource by lazy {
      StringResource("string:page_users_add_new_user_couldnt_invite_title", "page_users_add_new_user_couldnt_invite_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4574, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4486, 64),
      ))
    }

internal val Res.string.page_users_add_new_user_text: StringResource by lazy {
      StringResource("string:page_users_add_new_user_text", "page_users_add_new_user_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4635, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4551, 100),
      ))
    }

internal val Res.string.page_users_add_new_user_title: StringResource by lazy {
      StringResource("string:page_users_add_new_user_title", "page_users_add_new_user_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4732, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4652, 69),
      ))
    }

internal val Res.string.page_users_cant_invite: StringResource by lazy {
      StringResource("string:page_users_cant_invite", "page_users_cant_invite", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4826, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4722, 118),
      ))
    }

internal val Res.string.page_users_couldnt_load: StringResource by lazy {
      StringResource("string:page_users_couldnt_load", "page_users_couldnt_load", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4977, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4841, 87),
      ))
    }

internal val Res.string.page_users_remove_user_couldnt_remove_text: StringResource by lazy {
      StringResource("string:page_users_remove_user_couldnt_remove_text", "page_users_remove_user_couldnt_remove_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5077, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4929, 98),
      ))
    }

internal val Res.string.page_users_remove_user_text: StringResource by lazy {
      StringResource("string:page_users_remove_user_text", "page_users_remove_user_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5192, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5028, 95),
      ))
    }

internal val Res.string.page_users_remove_user_title: StringResource by lazy {
      StringResource("string:page_users_remove_user_title", "page_users_remove_user_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5304, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5124, 68),
      ))
    }

internal val Res.string.popup_user_invite_duration_1_month: StringResource by lazy {
      StringResource("string:popup_user_invite_duration_1_month", "popup_user_invite_duration_1_month", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5385, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5193, 54),
      ))
    }

internal val Res.string.popup_user_invite_duration_1_week: StringResource by lazy {
      StringResource("string:popup_user_invite_duration_1_week", "popup_user_invite_duration_1_week", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5436, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5248, 49),
      ))
    }

internal val Res.string.popup_user_invite_duration_text: StringResource by lazy {
      StringResource("string:popup_user_invite_duration_text", "popup_user_invite_duration_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5490, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5298, 99),
      ))
    }

internal val Res.string.popup_user_invite_duration_title: StringResource by lazy {
      StringResource("string:popup_user_invite_duration_title", "popup_user_invite_duration_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5594, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5398, 64),
      ))
    }

internal val Res.string.popup_user_invite_duration_until_end_of_day: StringResource by lazy {
      StringResource("string:popup_user_invite_duration_until_end_of_day", "popup_user_invite_duration_until_end_of_day", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5663, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5463, 59),
      ))
    }

internal val Res.string.push_notification_dialog_text: StringResource by lazy {
      StringResource("string:push_notification_dialog_text", "push_notification_dialog_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5723, 289),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5523, 293),
      ))
    }

internal val Res.string.push_notification_dialog_title: StringResource by lazy {
      StringResource("string:push_notification_dialog_title", "push_notification_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6013, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5817, 62),
      ))
    }

internal val Res.string.result: StringResource by lazy {
      StringResource("string:result", "result", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6084, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5880, 22),
      ))
    }

internal val Res.string.scenario_name: StringResource by lazy {
      StringResource("string:scenario_name", "scenario_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6111, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5903, 41),
      ))
    }

internal val Res.string.short_hour: StringResource by lazy {
      StringResource("string:short_hour", "short_hour", setOf(
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 10, 22),
      ))
    }

internal val Res.string.short_minute: StringResource by lazy {
      StringResource("string:short_minute", "short_minute", setOf(
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 33, 24),
      ))
    }

internal val Res.string.short_second: StringResource by lazy {
      StringResource("string:short_second", "short_second", setOf(
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 58, 24),
      ))
    }

internal val Res.string.show_scenario_delete_text: StringResource by lazy {
      StringResource("string:show_scenario_delete_text", "show_scenario_delete_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6153, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5945, 85),
      ))
    }

internal val Res.string.show_scenario_delete_title: StringResource by lazy {
      StringResource("string:show_scenario_delete_title", "show_scenario_delete_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6239, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6031, 62),
      ))
    }

internal val Res.string.user_legend_alert: StringResource by lazy {
      StringResource("string:user_legend_alert", "user_legend_alert", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6406, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6202, 41),
      ))
    }

internal val Res.string.user_legend_alert_not_validated: StringResource by lazy {
      StringResource("string:user_legend_alert_not_validated", "user_legend_alert_not_validated", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6302, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6094, 59),
      ))
    }

internal val Res.string.user_legend_alert_validated: StringResource by lazy {
      StringResource("string:user_legend_alert_validated", "user_legend_alert_validated", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6358, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6154, 47),
      ))
    }

internal val Res.string.uv_index: StringResource by lazy {
      StringResource("string:uv_index", "uv_index", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6456, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6244, 28),
      ))
    }

internal val Res.string.uv_index_extreme: StringResource by lazy {
      StringResource("string:uv_index_extreme", "uv_index_extreme", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/uv_index.commonMain.cvr", 10, 36),
        ResourceItem(setOf(), "${MD}values/uv_index.commonMain.cvr", 10, 36),
      ))
    }

internal val Res.string.uv_index_high: StringResource by lazy {
      StringResource("string:uv_index_high", "uv_index_high", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/uv_index.commonMain.cvr", 47, 29),
        ResourceItem(setOf(), "${MD}values/uv_index.commonMain.cvr", 47, 29),
      ))
    }

internal val Res.string.uv_index_low: StringResource by lazy {
      StringResource("string:uv_index_low", "uv_index_low", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/uv_index.commonMain.cvr", 77, 24),
        ResourceItem(setOf(), "${MD}values/uv_index.commonMain.cvr", 77, 24),
      ))
    }

internal val Res.string.uv_index_moderate: StringResource by lazy {
      StringResource("string:uv_index_moderate", "uv_index_moderate", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/uv_index.commonMain.cvr", 102, 37),
        ResourceItem(setOf(), "${MD}values/uv_index.commonMain.cvr", 102, 37),
      ))
    }

internal val Res.string.uv_index_very_high: StringResource by lazy {
      StringResource("string:uv_index_very_high", "uv_index_very_high", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/uv_index.commonMain.cvr", 140, 42),
        ResourceItem(setOf(), "${MD}values/uv_index.commonMain.cvr", 140, 38),
      ))
    }

internal val Res.string.validate: StringResource by lazy {
      StringResource("string:validate", "validate", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6485, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6273, 28),
      ))
    }

internal val Res.string.warn_customer_text_client: StringResource by lazy {
      StringResource("string:warn_customer_text_client", "warn_customer_text_client", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6514, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6302, 69),
      ))
    }

internal val Res.string.warn_customer_text_manager: StringResource by lazy {
      StringResource("string:warn_customer_text_manager", "warn_customer_text_manager", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6584, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6372, 58),
      ))
    }

internal val Res.string.you_are_connected: StringResource by lazy {
      StringResource("string:you_are_connected", "you_are_connected", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6647, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6431, 49),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("page_administrators_couldnt_load", Res.string.page_administrators_couldnt_load)
  map.put("page_administrators_remove_administrator_couldnt_remove_text", Res.string.page_administrators_remove_administrator_couldnt_remove_text)
  map.put("page_administrators_remove_administrator_text", Res.string.page_administrators_remove_administrator_text)
  map.put("page_administrators_remove_administrator_title", Res.string.page_administrators_remove_administrator_title)
  map.put("page_users_add_new_user_couldnt_invite_text", Res.string.page_users_add_new_user_couldnt_invite_text)
  map.put("page_users_add_new_user_couldnt_invite_title", Res.string.page_users_add_new_user_couldnt_invite_title)
  map.put("page_users_add_new_user_text", Res.string.page_users_add_new_user_text)
  map.put("page_users_add_new_user_title", Res.string.page_users_add_new_user_title)
  map.put("page_users_cant_invite", Res.string.page_users_cant_invite)
  map.put("page_users_couldnt_load", Res.string.page_users_couldnt_load)
  map.put("page_users_remove_user_couldnt_remove_text", Res.string.page_users_remove_user_couldnt_remove_text)
  map.put("page_users_remove_user_text", Res.string.page_users_remove_user_text)
  map.put("page_users_remove_user_title", Res.string.page_users_remove_user_title)
  map.put("popup_user_invite_duration_1_month", Res.string.popup_user_invite_duration_1_month)
  map.put("popup_user_invite_duration_1_week", Res.string.popup_user_invite_duration_1_week)
  map.put("popup_user_invite_duration_text", Res.string.popup_user_invite_duration_text)
  map.put("popup_user_invite_duration_title", Res.string.popup_user_invite_duration_title)
  map.put("popup_user_invite_duration_until_end_of_day", Res.string.popup_user_invite_duration_until_end_of_day)
  map.put("push_notification_dialog_text", Res.string.push_notification_dialog_text)
  map.put("push_notification_dialog_title", Res.string.push_notification_dialog_title)
  map.put("result", Res.string.result)
  map.put("scenario_name", Res.string.scenario_name)
  map.put("short_hour", Res.string.short_hour)
  map.put("short_minute", Res.string.short_minute)
  map.put("short_second", Res.string.short_second)
  map.put("show_scenario_delete_text", Res.string.show_scenario_delete_text)
  map.put("show_scenario_delete_title", Res.string.show_scenario_delete_title)
  map.put("user_legend_alert", Res.string.user_legend_alert)
  map.put("user_legend_alert_not_validated", Res.string.user_legend_alert_not_validated)
  map.put("user_legend_alert_validated", Res.string.user_legend_alert_validated)
  map.put("uv_index", Res.string.uv_index)
  map.put("uv_index_extreme", Res.string.uv_index_extreme)
  map.put("uv_index_high", Res.string.uv_index_high)
  map.put("uv_index_low", Res.string.uv_index_low)
  map.put("uv_index_moderate", Res.string.uv_index_moderate)
  map.put("uv_index_very_high", Res.string.uv_index_very_high)
  map.put("validate", Res.string.validate)
  map.put("warn_customer_text_client", Res.string.warn_customer_text_client)
  map.put("warn_customer_text_manager", Res.string.warn_customer_text_manager)
  map.put("you_are_connected", Res.string.you_are_connected)
}
